export default "__VITE_ASSET__B_BNVo38__"